import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UserModel } from '@core/model/user.model';
import { ItemInformationModel } from '@core/model/itemInformation.model';
import { MasterClientModel } from '@core/model/masterClient.model';
import { DimensionModel } from '@core/model/dimension.model';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { takeUntil } from 'rxjs/operators';
import { DimensionItemModel } from '@core/model/dimensionItem.model';
import { Subject } from 'rxjs';
import { ShoppingCartAdminModel } from '@core/model/shoppingCartAdmin.model';
import { SiteModel } from '@core/model/site.model';
import { CutsProjectModel } from '@core/model/custProject.model';
import { CommonService } from '@shared/service/common.service';
import { ItemService } from '@shared/service/items.service';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { ValidateStocksModel } from '@core/model/validateStocks.model';
import { ModalErrorComponent } from '../modal-error/modal-error.component';
import { utiles } from '@utl/environment';
import { UserService } from '@shared/service/user.service';

@Component({
  selector: 'app-modal-add-to-shopping-cart',
  templateUrl: './modal-add-to-shopping-cart.component.html',
  styleUrls: ['./modal-add-to-shopping-cart.component.scss']
})
export class ModalAddToShoppingCartComponent implements OnInit {

  private unsubscribe$ = new Subject<void>();
  public dimensionItemModel: DimensionItemModel = new DimensionItemModel();
  private userModel: UserModel = new UserModel();
  public dimensionColor: DimensionModel[] = [];
  public dimensionEstilo: DimensionModel[] = [];
  public dimensionTamano: DimensionModel[] = [];
  public dimensionConfig: DimensionModel[] = [];
  public itemInfoModel: ItemInformationModel = new ItemInformationModel();
  public dimensions: DimensionModel[] = [];
  productImage: any[];
  private siteModel: SiteModel = new SiteModel();
  private projectModel: CutsProjectModel = new CutsProjectModel();
  public colorSelected = '';
  public estiloSelected = '';
  public tamanoSelected = '';
  public configSelected = '';
  public colorId = 'color';
  public estiloId = 'estilo';
  public tamanoId = 'tamano';
  public configId = 'config';
  enableCartButton = true;
  imgDefault = environment.imgDefault;
  all = 'all';
  public ready = false;
  masterClientModel: MasterClientModel = new MasterClientModel();
  onCancel = new EventEmitter();
  onAccept = new EventEmitter();
  qty = 1;
  family = '';
  productInformation: ItemInformationModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productFamilyService: ProductFamilyService,
    private common: CommonService,
    private itemService: ItemService,
    private userService: UserService,
    public dialog: MatDialog) {
    if (this.data !== null && this.data !== undefined) {
      this.userModel = data.user;
      this.itemInfoModel = data.itemInfo;
      this.masterClientModel = data.masterClient;
      this.siteModel = data.site;
      this.projectModel = data.project;
      this.family = this.itemInfoModel.FamilyId;
      if (data.filters !== undefined) {
        let filters = data.filters;
        filters.forEach(element => {
          if (element.Filter === 'COLOR') {
            this.colorSelected = element.Value;
          }
          if (element.Filter === 'ESTILO') {
            if (this.family === 'ALUMINIO') {
              this.estiloSelected = '6063T5';
            } else {
              this.estiloSelected = element.Value.toUpperCase();
            }
          }
          if (element.Filter === 'TAMAÑO') {
            this.tamanoSelected = element.Value;
          }
          if (element.Filter === 'CONFIG') {
            this.configSelected = element.Value;
          }
        });
      }
    }
  }

  ngOnInit() {
    this.getProductDetail();
  }

  
  getProductDetail() {
    this.productInformation = new ItemInformationModel();
    this.productInformation.ItemId = this.itemInfoModel.ItemId;
    this.productInformation.UserId = this.userModel.UserId;
    this.productInformation.Color = this.colorSelected;
    if (this.family === 'ALUMINIO') {
      this.estiloSelected = '6063T5';
      this.productInformation.Style = this.estiloSelected;
    } else {
      this.productInformation.Style = this.estiloSelected;
    }

    this.productInformation.Size = this.tamanoSelected;
    this.productInformation.Config = this.configSelected;
    const modelcurrency = utiles.getCacheSelectedCurrency();
    this.productInformation.Currency = modelcurrency.CurrencyId;
    this.productInformation.CustAccount = this.masterClientModel.CustAccount;
    this.productInformation.ProjectId = this.projectModel.ProjectId;
  }
  
  getProductDimensions() {
    this.productFamilyService.getInventDimensionsByItems(this.itemInfoModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        response => {
          this.ready = true;
          if (response != null) {
            this.dimensions = response;
            this.dimensionColor = response;
            let hash = {};
            this.dimensionColor = this.dimensionColor.filter(function(current) {
              let exists = (!hash[current.Color] || false) && current.Color !== '' && current.Color !== undefined;
              hash[current.Color] = true;
              return exists;
            });
            this.dimensionEstilo = response;
            let hash2 = {};
            this.dimensionEstilo = this.dimensionEstilo.filter(function(current) {
              let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '' && current.Estilo !== undefined;
              hash2[current.Estilo] = true;
              return exists;
            });
            this.dimensionTamano = response;
            let hash3 = {};
            this.dimensionTamano = this.dimensionTamano.filter(function(current) {
              let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '' && current.Tamano !== undefined;
              hash3[current.Tamano] = true;
              return exists;
            });
            this.dimensionConfig = response;
            let hash4 = {};
            this.dimensionConfig = this.dimensionConfig.filter(function(current) {
              let exists = (!hash4[current.Config] || false) && current.Config !== '' && current.Config !== undefined;
              hash4[current.Config] = true;
              return exists;
            });
            if (this.colorSelected !== '') {
              this.setDimensionsValue(this.colorSelected, 'color');
            }
            if (this.estiloSelected !== '') {
              this.setDimensionsValue(this.estiloSelected, 'estilo');
            }
            if (this.tamanoSelected !== '') {
              this.setDimensionsValue(this.tamanoSelected, 'tamano');
            }
            if (this.configSelected !== '') {
              this.setDimensionsValue(this.configSelected, 'config');
            }

            if (this.verifyChange()) {
              this.enableCartButton = false;
            }
          }
          this.getProductDetail();
        });
  }

  setDimensionsValue(value, type) {
    if (value === 'all') {
      this.dimensionColor = [];
      this.dimensionEstilo = [];
      this.dimensionTamano = [];
      this.dimensionConfig = [];
      this.colorSelected = '';
      this.estiloSelected = '';
      this.tamanoSelected = '';
      this.configSelected = '';
      this.enableCartButton = true;
      this.dimensions.forEach(item => {
        this.dimensionColor.push(item);
        this.dimensionEstilo.push(item);
        this.dimensionTamano.push(item);
        this.dimensionConfig.push(item);
      });

      let hash = {};
      this.dimensionColor = this.dimensionColor.filter(function(current) {
        let exists = (!hash[current.Color] || false) && current.Color !== '' && current.Color !== undefined;
        hash[current.Color] = true;
        return exists;
      });
      let hash2 = {};
      this.dimensionEstilo = this.dimensionEstilo.filter(function(current) {
        let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '' && current.Estilo !== undefined;
        hash2[current.Estilo] = true;
        return exists;
      });
      let hash3 = {};
      this.dimensionTamano = this.dimensionTamano.filter(function(current) {
        let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '' && current.Tamano !== undefined;
        hash3[current.Tamano] = true;
        return exists;
      });
      let hash4 = {};
      this.dimensionConfig = this.dimensionConfig.filter(function(current) {
        let exists = (!hash4[current.Config] || false) && current.Config !== '' && current.Config !== undefined;
        hash4[current.Config] = true;
        return exists;
      });

    } else {
      switch (type) {
        case 'color':
          this.filterTamano(value, type);
          this.filterEstilo(value, type);
          this.filterConfig(value, type);
          break;
        case 'estilo':
          this.filterColor(value, type);
          this.filterTamano(value, type);
          this.filterConfig(value, type);
          break;
        case 'tamano':
          this.filterColor(value, type);
          this.filterEstilo(value, type);
          this.filterConfig(value, type);
          break;
        case 'config':
          this.filterColor(value, type);
          this.filterEstilo(value, type);
          this.filterTamano(value, type);
          break;
      }
    }
  }
 
  filterColor(value, type) {
    this.dimensionColor = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionColor.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionColor.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionColor.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionColor.push(item);
          }
          break;
      }
    });
    let hash = {};
    this.dimensionColor = this.dimensionColor.filter(function(current) {
      let exists = (!hash[current.Color] || false) && current.Color !== '' && current.Color !== undefined;
      hash[current.Color] = true;
      return exists;
    });
  }

  filterEstilo(value, type) {
    this.dimensionEstilo = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionEstilo.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionEstilo.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionEstilo.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionEstilo.push(item);
          }
          break;
      }
    });
    let hash2 = {};
    this.dimensionEstilo = this.dimensionEstilo.filter(function(current) {
      let exists = (!hash2[current.Estilo] || false) && current.Estilo !== '' && current.Estilo !== undefined;
      hash2[current.Estilo] = true;
      return exists;
    });
  }

  filterTamano(value, type) {
    this.dimensionTamano = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionTamano.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionTamano.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionTamano.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionTamano.push(item);
          }
          break;
      }
    });
    let hash3 = {};
    this.dimensionTamano = this.dimensionTamano.filter(function(current) {
      let exists = (!hash3[current.Tamano] || false) && current.Tamano !== '' && current.Tamano !== undefined;
      hash3[current.Tamano] = true;
      return exists;
    });
  }
  
  filterConfig(value, type) {
    this.dimensionConfig = [];
    this.dimensions.forEach(item => {
      switch (type) {
        case 'color':
          if (item.Color === value) {
            this.dimensionConfig.push(item);
          }
          break;
        case 'estilo':
          if (item.Estilo === value) {
            this.dimensionConfig.push(item);
          }
          break;
        case 'tamano':
          if (item.Tamano === value) {
            this.dimensionConfig.push(item);
          }
          break;
        case 'config':
          if (item.Config === value) {
            this.dimensionConfig.push(item);
          }
          break;
      }
    });
    let hash4 = {};
    this.dimensionConfig = this.dimensionConfig.filter(function(current) {
      let exists = (!hash4[current.Config] || false) && current.Config !== '' && current.Config !== undefined;
      hash4[current.Config] = true;
      return exists;
    });
  }

  changeCombo(value, type) {
    if (value === 'all' || value === undefined) {
      value = 'all';
      this.colorSelected = '';
      this.estiloSelected = '';
      this.tamanoSelected = '';
      this.configSelected = '';
      this.enableCartButton = true;
      this.itemInfoModel.SinglePrice = 0;
    }
    if (this.verifyChange()) {
      this.enableCartButton = false;
      this.getProductDetail();
    } else {
      this.setDimensionsValue(value, type);
    }
  }
  
  verifyChange() {
    let getDetail = false;

    if (this.dimensionColor.length > 0) {
      if (this.colorSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    if (this.dimensionEstilo.length > 0 && this.family !== 'ALUMINIO') {
      if (this.estiloSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    if (this.dimensionTamano.length > 0) {
      if (this.tamanoSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    if (this.dimensionConfig.length > 0) {
      if (this.configSelected !== '') {
        getDetail = true;
      } else {
        return false;
      }
    } else {
      return true;
    }

    return getDetail;
  }

  cancel() {
    this.onCancel.emit(false);
  }

  numberOnly(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
